// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3pDc0","overflowing":"ReadFullNote_overflowing__3YrlI"};